var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyurl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Copy_URL",
    "data-name": "Copy URL",
    transform: "translate(-5023 1224.807)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3041",
    "data-name": "Rectangle 3041",
    width: 24,
    height: 24,
    transform: "translate(5023 -1224.807)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "link-svgrepo-com",
    d: "M10.925,14.439a1.044,1.044,0,0,0,0-1.476,2.933,2.933,0,0,1,0-4.147L14.44,5.3a2.933,2.933,0,1,1,4.147,4.147L17.5,10.534a1.044,1.044,0,0,0,1.476,1.476l1.087-1.086a5.02,5.02,0,1,0-7.1-7.1L9.448,7.339a5.02,5.02,0,0,0,0,7.1,1.044,1.044,0,0,0,1.476,0Zm2.038-4.991a1.044,1.044,0,0,0,0,1.476,2.933,2.933,0,0,1,0,4.147L9.483,18.551A2.933,2.933,0,1,1,5.336,14.4l1.019-1.019a1.044,1.044,0,1,0-1.476-1.476L3.861,12.928a5.02,5.02,0,0,0,7.1,7.1l3.479-3.479a5.02,5.02,0,0,0,0-7.1,1.044,1.044,0,0,0-1.476,0Z",
    transform: "translate(5023.11 -1224.661)",
    fill: "#707070",
    stroke: "#fff",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyurl);
export default __webpack_public_path__ + "static/media/copyurl.fbded33063deb84e6259a8830ba4d66a.svg";
export { ForwardRef as ReactComponent };